import { View, Text, Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const HistoryCycleBlock = ({
  collectionFillingLevel,
  clientRegisteredWeight,
  numberOfPackmat,
  cycleChartImgUrl,
}) => {
  const { t } = useTranslation();

  const titleStyle = {
    fontSize: 18,
    color: "#00A7A6",
    fontFamily: "Mulish",
    fontWeight: 1000,
    letterSpacing: "1px",
  };

  return (
    <View
      style={{
        flexDirection: "row",
        padding: 20,
        justifyContent: "space-between",
      }}
    >
      <View style={{ width: "30%" }}>
        <View>
          <Text style={titleStyle}>{t("filling_cycle_line1")}</Text>
          {t("filling_cycle_line2") !== "" && (
            <Text style={titleStyle}>{t("filling_cycle_line2")}</Text>
          )}
        </View>
        <View style={{ marginTop: 35 }}>
          <Text
            style={{
              fontSize: 18,
              fontFamily: "Mulish",
              color: "#e81d7a",
              fontWeight: 1000,
            }}
          >
            {collectionFillingLevel}%
          </Text>
          <Text
            style={{
              fontSize: 12,
              fontFamily: "Mulish",
            }}
          >
            {t("Level at collection")}
          </Text>
        </View>
        {clientRegisteredWeight && (
          <View style={{ marginTop: 35 }}>
            <Text
              style={{
                fontSize: 18,
                fontFamily: "Mulish",
                color: "#e81d7a",
                fontWeight: 1000,
              }}
            >
              {`${clientRegisteredWeight} ${t("ton")}${clientRegisteredWeight > 1 ? "s" : ""}`}
            </Text>
            <Text
              style={{
                fontSize: 12,
                fontFamily: "Mulish",
              }}
            >
              {t("Registered weight")}
            </Text>
          </View>
        )}
        <View style={{ marginTop: 35 }}>
          <Text
            style={{
              fontSize: 18,
              fontFamily: "Mulish",
              color: "#e81d7a",
              fontWeight: 1000,
            }}
          >
            {numberOfPackmat}
          </Text>
          <Text
            style={{
              fontSize: 12,
              fontFamily: "Mulish",
            }}
          >
            {t("Packmat")}
            {numberOfPackmat > 1 ? "s" : ""}
          </Text>
        </View>
      </View>
      <View
        style={{
          width: "70%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {cycleChartImgUrl && (
          <Image
            style={{ width: "350px", height: "auto" }}
            src={cycleChartImgUrl}
          />
        )}
      </View>
    </View>
  );
};

export default HistoryCycleBlock;
